import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M7.28 6.22a.75.75 0 0 0-1.06 1.061l4.72 4.72-4.72 4.719a.75.75 0 1 0 1.06 1.06L12 13.061l4.72 4.72a.75.75 0 1 0 1.06-1.061L13.06 12l4.72-4.719a.75.75 0 1 0-1.06-1.06L12 10.94z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-close"}) } }